import {
  getGetUserEssentialQuestionsQueryKey,
  getGetTopEssentialQuestionsQueryKey,
  likeEssentialQuestions,
  unlikeEssentialQuestions,
  useDeleteEssentialQuestions,
  useGetUserEssentialQuestions,
  useGetTopEssentialQuestions,
} from "@packages/api/madlenAPI";
import { EssentialQuestionsCard } from "../../components/essential-questions/EssentialQuestionsCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { ActivitySuggestionItem } from "@packages/api/madlenAPI.schemas";
import i18n from "@packages/i18n/config";

interface ExtendedTool {
  id: number;
  imageUrl?: string;
  title?: string;
  prompt?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  videoUrl?: string;
  questions?: string[];
  activitySuggestions?: ActivitySuggestionItem[];
  createdAt?: string;
  isEditable?: boolean;
  contentLanguage?: string;
}

const EssentialQuestionsDetailComponent = ({
  tool,
}: {
  tool: ExtendedTool;
}) => {
  return (
    <EssentialQuestionsCard
      id={tool.id}
      author={tool.authorName || ""}
      title={tool.title || ""}
      description={tool.description || ""}
      questions={tool.questions || []}
      activitySuggestions={tool.activitySuggestions || []}
      imageUrl={tool.imageUrl!}
      videoUrl={tool.videoUrl}
      courseName={tool.courseName!}
      gradeLevel={tool.gradeLevel!}
      topic={tool.prompt || tool.title || ""}
      isImageLoading={false}
      createdAt={tool.createdAt ?? ""}
      isEditable={tool.isEditable}
      contentLanguage={tool.contentLanguage || i18n.language}
    />
  );
};

const EssentialQuestionsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserEssentialQuestions}
      useDeleteTool={useDeleteEssentialQuestions}
      getGetToolsQueryKey={getGetUserEssentialQuestionsQueryKey}
      useGetTopTools={useGetTopEssentialQuestions}
      likeTool={likeEssentialQuestions}
      unlikeTool={unlikeEssentialQuestions}
      getGetTopToolsQueryKey={getGetTopEssentialQuestionsQueryKey}
      toolType="essentialQuestions"
      toolPath="essential-questions"
      DetailComponent={EssentialQuestionsDetailComponent}
      colors={{
        light: "from-purple-400 to-indigo-500",
        dark: "dark:from-purple-300 dark:to-indigo-400",
        iconBg: "bg-purple-100 dark:bg-purple-900/50",
        iconColor: "text-purple-400 dark:text-purple-300",
        hover: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
      }}
      toolColor="purple"
      gradientColor="emerald"
    />
  );
};

export default EssentialQuestionsView;
